exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide[data-v-ff33506e]{position:fixed;width:100%;height:100%;z-index:10086}.guide-mask[data-v-ff33506e]{position:absolute;top:223px;left:205px;width:87px;height:92px;border-radius:8px;-webkit-box-shadow:0 0 0 2000px rgba(0,0,0,0.4);box-shadow:0 0 0 2000px rgba(0,0,0,0.4)}.guide-animation[data-v-ff33506e]{position:absolute;top:223px;left:205px;z-index:10088}.guide-step[data-v-ff33506e]{position:absolute;left:50%;width:120px;margin-left:-60px;bottom:169px;z-index:10088;text-align:center;color:#ffffff;cursor:pointer}\n", ""]);

// exports
